import { AFTERNOON_SHIFT_START_INDEX } from 'entities/bell-schedule/create/model/config';
import type { ParsedBell } from '../validators';

export const getBellShiftIndex = (parsedBell?: ParsedBell, index?: number) => {
  const lessonIndex = parsedBell?.index ?? index ?? 0;
  return lessonIndex < AFTERNOON_SHIFT_START_INDEX
    ? `${lessonIndex + 1} первой смены`
    : `${lessonIndex - AFTERNOON_SHIFT_START_INDEX + 1} второй смены`;
};
